import { FormControl } from "@angular/forms";

export const emailPattern = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z.]{2,6}$/;
export const mobilePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

export function formatAmount(amount: any) {
	if (!isNaN(amount) && amount != null && amount != undefined) {
		return amount.toLocaleString();
	} else {
		return amount;
	}
}

export function password_validation(control: FormControl) {
	let password: any = control.value;
	if (password == null || password == undefined) {
		password = "";
	}
	let errObj: any = {};
	if (password.length < 8) {
		errObj.minlengtherror = true;
	}
	const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	if (!specialChars.test(password)) {
		errObj.specialcharerror = true;
	}
	const upper = /[A-Z]/;
	const lower = /[a-z]/;
	const digit = /\d/;
	if (!upper.test(password)) {
		errObj.uppercaseerror = true;
	}
	if (!lower.test(password)) {
		errObj.lowercaseerror = true;
	}
	if (!digit.test(password)) {
		errObj.digiterror = true;
	}
	return errObj ? errObj : null;
}

export function noWhitespaceInRequiredValidator(control: FormControl) {
	let val: any = control.value;
	if (val == null) {
		return { 'required': true };
	}
	let type = typeof val;
	if (type == "number" || type == "bigint" || type == "object") {
		return null;
	}
	const isWhitespace = (control.value || '').trim().length === 0;
	const isValid = !isWhitespace;
	return isValid ? null : { 'required': true };
}

export const task_management_access_modules: any = [
	{
		module: "Task Management",
		access: [
			{ key: "create_task", name: "Create Task" },
			{ key: "edit_task", name: "Edit Task" },
			{ key: "delete_task", name: "Delete Task" },
			{ key: "change_task_status", name: "Change Task Status" },
			{ key: "finish_task", name: "Mark as Finished" },
			{ key: "task_excel", name: "Download Task Excel" },
			{ key: "create_recurring_task", name: "Create Recurring Task" },
			{ key: "edit_recurring_task", name: "Edit Recurring Task" },
			{ key: "delete_recurring_task", name: "Delete Recurring Task" },
		]
	},
	{
		module: "Attendance",
		access: [
			{ key: "attendance_module", name: "Attendance" },
			{ key: "regularization_module", name: "Regularization" },
			{ key: "leave_module", name: "Leave" },
			{ key: "roster_module", name: "Roster" },
		]
	},
	{
		module: "Company News Board",
		access: [
			{ key: "create_news", name: "Create News" },
			{ key: "edit_news", name: "Edit News" },
			{ key: "delete_news", name: "Delete News" },
		]
	},
	{
		module: "Holiday Master",
		access: [
			{ key: "create_holiday", name: "Create Holiday" },
			{ key: "edit_holiday", name: "Edit Holiday" },
			{ key: "delete_holiday", name: "Delete Holiday" },
		]
	},
	{
		module: "Events",
		access: [
			{ key: "create_event", name: "Create Event" },
			{ key: "edit_event", name: "Edit Event" },
			{ key: "delete_event", name: "Delete Event" },
		]
	}
];

export const splitPattern = new RegExp('[,;\t\r\n]+');

export function isImage(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "png" || ext_lower == "jpg" || ext_lower == "jpeg" || ext_lower == "jfif" || ext_lower == "gif";
	} catch (error) {
		return false;
	}
}

/* export const defaultBodyOld1 = "Good Day Captain,\n\nGreetings from the Duty of Care (DOC) team at 3Cube Medicare.\n\n\
As part of your companies dedicated efforts towards health, wellbeing and safety of crew onboard 3Cube Medicare is appointed as your Vessel Doctor providing 24x7 Remote Medical Assistance (RMA).\n\
The RMA station is manned 24x7 by a team of Doctors, Surgeons, Specialists, Psychologists, etc - all available to assist the ship command with prompt and suitable remedy/treatment. \n\
We strongly recommend to reach out to us for ALL MEDICAL CONCERNS, HOWEVER SMALL OR BIG. You are requested, NOT TO SELF-DIAGNOSE AND TREAT.\n\n The service also includes Wellness program wherein Health/Wellness/Wellbeing leaflets will be sent to your good vessel periodically to share with the crew and discuss during toolbox meetings.\n\n There will be campaigns and health surveys conducted periodically. Your vessels participation is crucial to the success and positive impact of such initiatives. \n\n\
We look forward to interacting with you soon.\nOur team is here for your 24x7! \n\
KEY CONTACTS \n\
1. For Medical Assistance, please note our Primary Email Id - rma@dutyofcare365.com and Alternate Email Id - rma@3cubemedicare.com \n\
2. For any queries related to Wellness, our Email Id is wellness@3cubemedicare.com \n\
We take this opportunity to welcome you to the Duty of Care 365 Services.\nWe request you to send us Updated Medical Chest Inventory and Medical Chest Certificate for us to configure it with our system.\n\n\
With this email the following documents are attached:\n\
1. SMR Form & Contact Card (to send along with medical queries) \n\
2. 3Cube Posters to put on common areas \n\n\
We request you to please confirm the receipt of this email.\n\n\
Best Regards,\nDOC Team\n3Cube Medicare\nPHONE - +91 80-6912-3333\nEmail Id  - rma@dutyofcare365.com";
export const defaultBodyOld2 = "Good Day Captain,\n\nGreetings from the Duty of Care (DOC) team at 3Cube Medicare.\n\n\
As part of your company’s dedicated efforts towards health, wellbeing and safety of crew onboard, 3Cube Medicare is appointed as your Vessel Doctor providing 24x7 Remote Medical Assistance (RMA).\n\n The RMA station is manned 24x7 by a team of Doctors, Surgeons, Specialists, Psychologists, etc - all available to assist the ship command with prompt and suitable remedy/treatment. \n\n We strongly recommend you to reach out to us for ALL MEDICAL CONCERNS, HOWEVER SMALL OR BIG. You are requested, NOT TO SELF-DIAGNOSE AND TREAT.\n\n The service also includes Wellness program wherein Health/Wellness/Wellbeing leaflets will be sent to your good vessel periodically to share with the crew and discuss during toolbox meetings.\n\n There will be campaigns and health surveys conducted periodically. Your vessel’s participation is crucial to the success and positive impact of such initiatives. \n\n\
We look forward to interacting with you soon.\n\nOur team is here for your 24x7! \n\n KEY CONTACTS \n\
1. For Medical Assistance, please note our Primary Email Id - rma@dutyofcare365.com and Alternate Email Id - rma@3cubemedicare.com \n\
2. For any queries related to Wellness, our Email Id is wellness@3cubemedicare.com \n\n We take this opportunity to welcome you to the Duty of Care 365 Services.\n\nWe request you to send us Updated Medical Chest Inventory and Medical Chest Certificate for us to configure it with our system.\n\n\
With this email the following documents are attached:\n\
1. SMR Form & Contact Card (to send along with medical queries) \n\
2. 3Cube Posters to put on common areas \n\n\
Request you to please confirm the receipt of this email and its understanding.\n\n\
Best Regards,\nDOC Team\n3Cube Medicare\nPHONE - +91 80-6912-3333\nEmail Id  - rma@dutyofcare365.com"; */
export const defaultBody = '<p>Good Day Captain,</p><p>Greetings from the Duty of Care (DOC) team at 3Cube Medicare.</p><p>As part of your company’s dedicated efforts towards health, wellbeing and safety of crew onboard, 3Cube Medicare is appointed as your Vessel Doctor providing 24x7 Remote Medical Assistance (RMA) and also for Ship Medical Chest Management, Replenishment of Medicines and Annual Certification.   </p><p>The RMA station is manned 24x7 by a team of Doctors, Surgeons, Specialists, Psychologists, etc - all available to assist the ship’s command with prompt and suitable remedy/treatment. </p><p>We strongly recommend you to reach out to us for ALL MEDICAL CONCERNS, HOWEVER SMALL OR BIG. You are requested, NOT TO SELF-DIAGNOSE AND TREAT. </p><p>The service also includes Wellness program wherein Health/Wellness/Wellbeing leaflets will be sent to your good vessel periodically to share with the crew and discuss during your safety/toolbox meetings. </p><p>There will be campaigns and health surveys conducted periodically. Your vessel’s participation is crucial to the success and positive impact of such initiatives. </p><p>With this email the following documents are attached: </p><p>1. SMR Form &amp; Contact Card (to send along with medical queries) </p><p>2. 3Cube Posters to put on common areas </p><p>3Cube Medicare will also remotely manage your<s> </s>vessel’s medical chest inventory and ensure timely replenishment to be in line with Flag State requirements. </p><p>As part of this service: </p><ul><li>We will request for the inventory periodically.  </li><li>Replenishment will be planned once a year (or maximum twice annually, if required). </li><li>A valid Medical Chest Certificate will be issued upon completion of inventory review and replenishment. </li><li>Request you to kindly share with us your current Medical Chest Inventory (template attached) and the existing Medical Chest Certificate with validity. </li></ul><p>This is aimed at ensuring your vessel’s medical supplies remain adequately stocked throughout the year and compliant at the time re-certification. </p><p>We look forward to interacting with you soon. </p><p>Our team is here for your 24x7! Please reach out to: </p><p>Remote Medical Assistance – <a href="mailto:rma@dutyofcare365.com" rel="noopener noreferrer" target="_blank" style="color: rgb(5, 99, 193);">rma@dutyofcare365.com</a> / <a href="mailto:rma@3cubemedicare.com" rel="noopener noreferrer" target="_blank" style="color: rgb(5, 99, 193);">rma@3cubemedicare.com</a>  </p><p>Pharma – <a href="mailto:pharma@dutyofcare365.com" rel="noopener noreferrer" target="_blank" style="color: rgb(5, 99, 193);">pharma@dutyofcare365.com</a> / <a href="mailto:pharma@3cubemedicare.com" rel="noopener noreferrer" target="_blank" style="color: rgb(5, 99, 193);">pharma@3cubemedicare.com</a>  </p><p>Wellness – <a href="mailto:wellness@3cubemedicare.com" rel="noopener noreferrer" target="_blank" style="color: rgb(5, 99, 193);">wellness@3cubemedicare.com</a>  </p><p></p><p>(<u style="color: rgb(0, 120, 212);">Wellness is</u> regarding wellbeing articles, general health campaigns etc. <span style="background-color: yellow;">PLEASE NOTE THIS EMAIL ADDRESS IS NOT FOR MEDICAL </span><u style="background-color: yellow; color: rgb(0, 120, 212);">ASSISTANCE </u><span style="background-color: yellow;">REQUESTS.)</span> </p><p></p><p> We take this opportunity to welcome you to the 3Cube Duty of Care 365 Services. </p><p>Request you to please acknowledge and confirm receipt of this email and its understanding. </p><p>Best Regards, </p><p>DOC Team </p><p>3Cube Medicare </p><p>PHONE - +91 80-6912-3333 </p><p>Email Id - <a href="mailto:rma@dutyofcare365.com" rel="noopener noreferrer" target="_blank" style="color: rgb(5, 99, 193);">rma@dutyofcare365.com</a> </p><p></p>';

export const closure_status_list = [
	{ id: 112, name: "Medical Evac" },
	{ id: 113, name: "Medical Sign-off" },
	{ id: 114, name: "Recovered" },
	{ id: 115, name: "Fatality (Reported)" },
	{ id: 116, name: "Suicides (Reported)" },
	{ id: 118, name: "Company/Vessel Sign-off" }
];